import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { AudiencesPage } from '@/components/audiences/audiences-page';
import {
  AudienceSource,
  AudienceStatus,
  AudienceSyncPolicy,
} from '@/types/generated/enums';
import { loadNamespaces } from '@/lib/i18n/i18n';

const searchSchema = z.object({
  source: z.nativeEnum(AudienceSource).optional(),
  status: z.nativeEnum(AudienceStatus).optional(),
  sync_policy: z.nativeEnum(AudienceSyncPolicy).optional(),
  platform_presence: z.enum(['google_only', 'meta_only', 'both']).optional(),
  sort_by: z.enum(['name', 'size', 'recency']).optional(),
  sort_dir: z.enum(['asc', 'desc']).optional(),
  q: z.string().optional(),
});

export const Route = createFileRoute('/_authenticated/audiences/')({
  loader: () => loadNamespaces('audiences'),
  validateSearch: searchSchema,
  staticData: {
    title: 'route.audiences.title',
  },
  component: AudiencesPage,
});
